import React from 'react';

type InfoCardCloseProps = {
  onClose: () => void;
};

export default function InfoCardClose({ onClose }: InfoCardCloseProps) {
  return (
    <button type="button" className="info-card__close" onClick={onClose} aria-label="Close menu">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" />
      </svg>
    </button>
  );
}
